export function checkNum(num) {
    return Boolean(num || num === 0);
}
